import { TabProps } from './secondarySidebar';

export enum SettingsSection {
  ALERTS = 'ALERTS',
  BILLING = 'BILLING',
  USER = 'USER',
  TEAM = 'TEAM'
}

/** Icon, status and `matchPaths` are the page tabs' own fields, so a published tab list passes straight through. */
export interface SettingsNavItem extends Pick<TabProps, 'icon' | 'SVGIcon' | 'status' | 'matchPaths'> {
  label: string;
  /** Absolute route the item links to; also what marks it active (prefix-matched). */
  path: string;
  /**
   * Set explicitly on every item rather than derived from the label: the team pages emit the
   * raw label ('Members', 'Data & Privacy') while the others emit a slug, and automation depends
   * on both conventions surviving the move from the tab strips into this sidebar.
   */
  dataId: string;
  /** Nested under the item, which then renders as a collapsible group. */
  children?: SettingsNavItem[];
}

export interface SettingsNavSection {
  id: SettingsSection;
  title: string;
  items: SettingsNavItem[];
  /** Draw `items` as placeholders: the section is still being resolved. */
  loading?: boolean;
}

/** Every synchronous signal the nav descriptors gate on. Resolved once per render by the hook. */
export interface SettingsNavVisibilityContext {
  isTeamEditor: boolean;
  isWorkspacesEnabled: boolean;
  isISVTeam: boolean;
  isVPCPeeringConnectionEnabled: boolean;
  isEdgeAlertsEnabled: boolean;
  isWebhookEventsEnabled: boolean;
  isAuditTablesEnabled: boolean;
  isWorkspaceTeam: boolean;
}

export interface SettingsNavItemConfig extends Omit<SettingsNavItem, 'children'> {
  visibleWhen?: (ctx: SettingsNavVisibilityContext) => boolean;
  children?: SettingsNavItemConfig[];
}
